<div class="w-full report-success-dialog">
    <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
      
            <div class="flex text-xl space-x-2">
              <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="#28A138"  class="mt-1 h-10 w-10 icon icon-tabler icons-tabler-filled icon-tabler-circle-check"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" /></svg>
            <div class="flex flex-col pt-1">
              <h1 class="font-bold text-3xl"> {{'text.report.moved.success' | translate}}</h1>
           <div class="text-gray-500 text-base">
            "{{data?.data?.sourceFolder}}" {{'text.has.been.moved' | translate}} "{{data?.data?.destinationFolder?.folder_name}}"
        </div>
            
        </div>
        </div>
    
      <div class="flex items-center mr-1">

        <span mat-dialog-close class="rounded-full relative -top-4 flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2 mb-5">
          <em class="ti ti-x text-xl font-bold"></em>
        </span>
      </div>
    </div>
    <div mat-dialog-actions class="flex justify-end border-t border-gray-300 mb-0 px-6 zuper-dialog-footer">
          <button type="submit" mat-dialog-close
            class="min-w-24 px-6 items-center py-2 b-1 btn-primary shadow-sm text-white font-medium rounded-md text-white-600 bg-red-600 btn-small">{{'text.okay' | translate}}
          </button>
        </div>
      </div>